module.exports = __webpack_public_path__ + "img/c553c59050ee89dd57dd9d459145ca76.png";